<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()" [onyxAutoFocus]="mode()">
    @let controls = form().controls;
    @if (!companyData()) {
      <onyx-text-field
        class="span"
        [formControl]="controls.companyName"
        label="labels.fullName"
        [size]="32"
      ></onyx-text-field>
    }

    <onyx-text-field
      class="span"
      [formControl]="controls.displayName"
      label="labels.displayName"
      [maxLength]="48"
      [size]="32"
    ></onyx-text-field>

    @if (!companyData()) {
      <onyx-dropdown
        [formControl]="controls.country"
        label="labels.country"
        [options]="countries$ | async"
        [search]="true"
        [size]="32"
      ></onyx-dropdown>

      <onyx-text-field
        [formControl]="controls.vatId"
        label="labels.vatId"
        [size]="32"
      ></onyx-text-field>
    }

    <onyx-dropdown
      [formControl]="controls.types"
      label="labels.businessType"
      [options]="types$ | async"
      [multiple]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-phone-number-input
      [formControl]="controls.phone"
      label="labels.officePhone"
      [size]="32"
    ></onyx-phone-number-input>
  </form>
</onyx-section>
